//#region Libraries
import { useEffect } from "react";
//#endregion
//#region Styles
import { ContainerParts } from "components/styles";
//#endregion
//#region Components
import Part1 from "./components/Part1/Part1";
import LocationPartForm from "views/components/LocationPartForm/LocationPartForm";
import PublicPartForm from "views/components/PublicPartForm/PublicPartForm";
import useLoadingRequest from "components/Preloader/utils/hooks/useLoadingRequest";
import Preloader from "components/Preloader/Preloader";
import { LOCATION_IDS } from "config/constants";
import useTeacherZoomAccountDetailRequest from "../../../utils/hooks/useTeacherZoomAccountDetailRequest";
//#endregion

const Step2 = ({
	eventResumeData,
	form,
	changeForm,
	changeErrorText,
	errors,
	locations,
	inscriptionEventTypes,
	allCampus,
	modalities,
	campusEnvironments,
	errorTexts,
	teacherZoomAccountDetail,
}) => {
	const loadingRequest = useLoadingRequest();
	const { isActiveTeacherZoomAccount, fillTeacherZoomAccountDetail } = useTeacherZoomAccountDetailRequest({
		loadingRequest, teacherZoomAccountDetail,
		changeErrorText, changeFieldPart1, errors, form
	})
	//#region Effects
	useEffect(() => {
		if (!teacherZoomAccountDetail.value) return;
		// Revisando si ya se tiene zoomTypeId
		if (eventResumeData && eventResumeData.step2.zoomTypeId > 0) return;
		const newZoomTypeId = isActiveTeacherZoomAccount()
			? teacherZoomAccountDetail.value.zoomTypeId
			: 0;
		changeFieldPart2("zoomTypeId", newZoomTypeId);
	}, [teacherZoomAccountDetail.value]);
	useEffect(() => {
		fillTeacherZoomAccountDetailWhenResumeDataExists();
	}, [eventResumeData]);
	//#endregion
	//#region Functions
	const fillTeacherZoomAccountDetailWhenResumeDataExists = () => {
		if (!eventResumeData || form.part2.locationId !== LOCATION_IDS.ZOOM)
			return;
		const { free, search } = eventResumeData.step2.teacher;
		let payload = null;
		if (free?.accountId) payload = { teacherAccountId: free.accountId };
		else if (search?.id) payload = { teacherId: search.id };
		if (!payload) return;
		fillTeacherZoomAccountDetail({
			teacher: payload,
		});
	};
	function changeFieldPart1(field, value, errorValue) {
		changeForm("part1", field, value, errorValue);
	};
	const changeFieldPart2 = (field, value, errorValue) => {
		changeForm("part2", field, value, errorValue);
	};
	const changeFieldPart3 = (field, value, errorValue) => {
		changeForm("part3", field, value, errorValue);
	};
	//#endregion
	return (
		<>
			<Preloader {...loadingRequest.value} />
			<ContainerParts>
				<Part1
					form={form.part1}
					changeField={changeFieldPart1}
					fillTeacherZoomAccountDetail={fillTeacherZoomAccountDetail}
					errors={errors.part1}
					errorTexts={errorTexts}
					allCampus={allCampus}
				/>
				<LocationPartForm
					form={form.part2}
					changeField={changeFieldPart2}
					errors={errors.part2}
					errorTexts={errorTexts}
					locations={locations}
					inscriptionTypes={inscriptionEventTypes}
					allCampus={allCampus}
					campusEnvironments={campusEnvironments}
					teacherZoomAccountDetail={teacherZoomAccountDetail.value}
					fillTeacherZoomAccountDetail={fillTeacherZoomAccountDetail}
					as="evento"
				/>
				<PublicPartForm
					form={form.part3}
					changeField={changeFieldPart3}
					titleListSecion="¿A quiénes está dirigido el evento?"
					errors={errors.part3}
					allCampus={allCampus}
					modalities={modalities}
					errorTexts={errorTexts}
					formatFileListSection="/Documents/formato_publico_codigo_estudiantes.xlsx"
					as="evento"
				/>
			</ContainerParts>
		</>
	);
};
export default Step2;
